export var AssignmentType;
(function (AssignmentType) {
    AssignmentType[AssignmentType["Client"] = 0] = "Client";
    AssignmentType[AssignmentType["Reason"] = 1] = "Reason";
})(AssignmentType || (AssignmentType = {}));
